import {
  FETCH_PACKAGE_DENIAL_REASONS_PENDING,
  FETCH_PACKAGE_DENIAL_REASONS_REJECTED,
  FETCH_PACKAGE_DENIAL_REASONS_FULFILLED,
  SET_MAIN_DENIAL_REASON,
} from 'constants/packageDenialReasons';

const initialState = {
  pending: true,
  success: false,
  error: {},
  packageDenialReasons: {},
  packageMainDenialReason: {},
};

export const packageDenialReasons = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PACKAGE_DENIAL_REASONS_PENDING:
      return { ...state, pending: true, error: {} };

    case FETCH_PACKAGE_DENIAL_REASONS_REJECTED:
      return { ...state, pending: false, success: false, error: action.error };

    case FETCH_PACKAGE_DENIAL_REASONS_FULFILLED:
      return {
        ...state,
        packageDenialReasons: action.data.results,
        pending: false,
        success: true,
        error: {},
      };

    case SET_MAIN_DENIAL_REASON:
      return {
        ...state,
        packageMainDenialReason: action.data,
      };

    default:
      return state;
  }
};


// WEBPACK FOOTER //
// ./src/reducers/packageDenialReasons.js